/**
 * The last value that was there. A read keyed by a window loses its data
 * when the window changes; a chart or a headline that must not go blank
 * keeps the previous one with this until the new one lands (the replicas
 * chart, TRA-1297, and the metrics page's capacity band, TRA-1592).
 */

import { useState } from 'react'

export function useLastDefined<T>(value: T | undefined): T | undefined {
  const [last, setLast] = useState(value)
  if (value !== undefined && value !== last) setLast(value)
  return value ?? last
}
